/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DuplicaGiornataRequestDTO
 */
export interface DuplicaGiornataRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof DuplicaGiornataRequestDTO
     */
    idPersonale?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof DuplicaGiornataRequestDTO
     */
    data?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DuplicaGiornataRequestDTO
     */
    dataDuplica?: Date;
}

/**
 * Check if a given object implements the DuplicaGiornataRequestDTO interface.
 */
export function instanceOfDuplicaGiornataRequestDTO(value: object): value is DuplicaGiornataRequestDTO {
    return true;
}

export function DuplicaGiornataRequestDTOFromJSON(json: any): DuplicaGiornataRequestDTO {
    return DuplicaGiornataRequestDTOFromJSONTyped(json, false);
}

export function DuplicaGiornataRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicaGiornataRequestDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'dataDuplica': json['dataDuplica'] == null ? undefined : (new Date(json['dataDuplica'])),
    };
}

export function DuplicaGiornataRequestDTOToJSON(json: any): DuplicaGiornataRequestDTO {
    return DuplicaGiornataRequestDTOToJSONTyped(json, false);
}

export function DuplicaGiornataRequestDTOToJSONTyped(value?: DuplicaGiornataRequestDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'data': value['data'] == null ? undefined : ((value['data'] as any).toISOString()),
        'dataDuplica': value['dataDuplica'] == null ? undefined : ((value['dataDuplica']).toISOString()),
    };
}

